import moment from "moment";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";

function WhatsappChatMessageItem({ message, username, t, config, settings }) {
  const isRTL = config?.direction === "rtl";

  const rowStyle = {
    display: "flex",
    justifyContent: message.is_from_merchant
      ? isRTL
        ? "flex-start"
        : "flex-end"
      : isRTL
      ? "flex-end"
      : "flex-start",
    marginBottom: 10,
    width: "100%",
  };

  const bubbleStyle = {
    background: message.is_from_merchant ? "#0099cc" : "#F5F5F5",
    color: message.is_from_merchant ? "white" : "black",
    padding: "10px 12px",
    borderRadius: 14,
    borderBottomLeftRadius: message.is_from_merchant
      ? isRTL
        ? 6
        : 14
      : isRTL
      ? 14
      : 6,
    borderBottomRightRadius: message.is_from_merchant
      ? isRTL
        ? 14
        : 6
      : isRTL
      ? 6
      : 14,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    overflowWrap: "anywhere",
    fontSize: 13,
    lineHeight: 1.45,
    boxShadow: "0 1px 0 rgba(0,0,0,0.03)",
    direction: isRTL ? "rtl" : "ltr",
    textAlign: isRTL ? "right" : "left",
  };
  const metaStyle = {
    fontSize: 11,
    color: "#999",
    margin: message.is_from_merchant
      ? isRTL
        ? "4px 0 0 6px"
        : "4px 6px 0 0"
      : isRTL
      ? "4px 6px 0 0"
      : "4px 0 0 6px",
    textAlign: message.is_from_merchant
      ? isRTL
        ? "left"
        : "right"
      : isRTL
      ? "right"
      : "left",
    direction: isRTL ? "rtl" : "ltr",
  };

  return (
    <div key={message.id} style={rowStyle}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: message.is_from_merchant
            ? isRTL
              ? "flex-start"
              : "flex-end"
            : isRTL
            ? "flex-end"
            : "flex-start",
          width: "100%",
        }}
      >
        <div style={bubbleStyle}>
          {message.image_url && (
            <img
              src={message.image_url}
              alt="message"
              style={{
                maxWidth: 220,
                maxHeight: 220,
                borderRadius: 10,
                display: "block",
                marginBottom: message.text ? 6 : 0,
                cursor: "pointer",
              }}
            />
          )}
          {message.text && <div>{message.text}</div>}
        </div>
        <div style={metaStyle}>
          {message.status === "failed" && (
            <p style={{ color: "red", fontWeight: "bold" }}>{t("Failed")}</p>
          )}
          {message.customer_name
            ? `${
                message.customer_name === username
                  ? t("me")
                  : message.customer_name
              } • `
            : ""}
          {message.created_at
            ? moment.utc(message.created_at).local().format("YYYY-MM-DD HH:mm")
            : ""}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  config: state.config,
  is_staff: state.auth.is_staff,
  username: state.auth.username,
  settings: state.auth.settings,
});

export default connect(mapStateToProps)(
  withNamespaces()(WhatsappChatMessageItem)
);
